<template>
  <el-date-picker
    v-model="date"
    type="daterange"
    @change="handleChange"
    value-format="yyyy-MM-dd"
    format="yyyy-MM-dd"
    range-separator="至"
    :size="size"
    :clearable="!closeclearable"
    :picker-options="allDate ? '' : (options || pickerOptions1)"
    :disabled="disabled"
    :start-placeholder="value[0] || '开始时间'"
    :end-placeholder="value[1] || '结束时间'">
  </el-date-picker>
</template>
<script>
import Config from '@/conf/index'
export default {
  name: 'DatesPicker',
  props: [
    'value',
    'size',
    'allDate',
    'closeclearable',
    'options',
    'disabled',
    'dateRange'
  ],
  data () {
    return {
      date: [],
      pickerOptions1: {
        disabledDate (time) {
          // var newDate = new Date()
          // return time.getTime() > Date.now() || time.getTime() < (newDate.getTime() - 3600 * 1000 * 24 * 365)
          // return time.getTime() > Date.now() || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 365)
          return time.getTime() > Date.now()
        }
      }
    }
  },
  watch: {
    'value': {
      handler (oldValue, newValue) {
        // if (oldValue !== '') {
        //   // this.date = this.value
        //   // this.$emit('change')
        // }
        this.date = this.value
        // console.log('val', val)
      },
      deep: true
    }
  },
  methods: {
    handleChange () {
      if (this.date && (new Date(this.date[1]).getTime() - new Date(this.date[0]).getTime() > 3600 * 1000 * 24 * (this.dateRange ? this.dateRange : Config.dateRange))) {
        this.date = this.value
        this.$message.error('仅支持选取' + (this.dateRange ? this.dateRange : Config.dateRange) + '天的日期区间！')
      } else {
        this.$emit('input', this.date || [])
      }
    }
    // dateInterval: (type) => {
    //   var kv = {
    //     'day': 1,
    //     'week': 7,
    //     'month': 30,
    //     'quarter': 122,
    //     'year': 365
    //   }
    //   var start = new Date()
    //   var end = new Date()
    //   start.setDate(start.getDate() - kv[type])
    //   var _start = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate()
    //   var _end = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()
    //   return [_start, _end].join(',')
    // }
  },
  mounted () {
    this.date = this.value
    // if (this.datePicker) {
    //   var interval = this.dateInterval(this.datePicker)
    //   this.date = interval.split(',')
    //   this.handleChange(this.date)
    // }
    // if (this.isDate) {
    //   this.date = new Date()
    //   this.handleChange(this.date)
    // }
  }
}
</script>
